// @flow
import React, { Component, Fragment } from "react";

import { StyledTextField, StyledSelect } from "imagus-components";
import { AusStates } from "../../../global/types/AusStates";

import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

type AddressBlockPropsType = {
  title: string,
  address: string,
  suburb: string,
  postcode: string,
  city: string,
  state: string,
  other_state: string,
  country: string,
  handleTextChange: Function,
  handleSelectChange: Function
};

class AddressBlock extends Component<AddressBlockPropsType, *> {
  render(): React$Element<*> {
    return (
      <Card style={{ width: "100%" }}>
        <CardContent>
          <Typography variant="h6">{this.props.title}</Typography>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <StyledTextField
                isRequired={false}
                label="Address"
                name="address"
                value={this.props.address}
                onChange={this.props.handleTextChange}
                inpuType="text"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <StyledTextField
                isRequired={false}
                label="Suburb"
                name="suburb"
                value={this.props.suburb}
                onChange={this.props.handleTextChange}
                inpuType="text"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <StyledTextField
                isRequired={false}
                label="Post Code"
                name="postcode"
                value={this.props.postcode}
                onChange={this.props.handleTextChange}
                inpuType="number"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <StyledTextField
                isRequired={false}
                label="City"
                name="city"
                value={this.props.city}
                onChange={this.props.handleTextChange}
                inpuType="text"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              {this.props.state === "Other" ? (
                <StyledTextField
                  isRequired={false}
                  label="Specify State Name"
                  name="other_state"
                  value={this.props.other_state}
                  onChange={this.props.handleTextChange}
                  inpuType="text"
                />
              ) : (
                <StyledSelect
                  value={this.props.state}
                  onChange={this.props.handleSelectChange}
                  name="state"
                  label="State"
                  isRequired={false}
                  menus={AusStates}
                  isStyled
                />
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              <StyledTextField
                isRequired={false}
                label="Country"
                name="country"
                value={this.props.country}
                onChange={this.props.handleTextChange}
                inpuType="text"
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default AddressBlock;
